import { isBrowser } from './jsBridge';

// @ts-ignore
export const isRunAsSubApp = isBrowser ? Boolean(window.$wujie) : false;

type WujieEventName =
  | 'routeChange'
  | 'currentWallet'
  | 'assetInfo'
  | 'showWalletConnectModal'
  | 'userInfo'
  | 'wallets'
  | 'chains'
  | `callHecateResp${string}`
  | 'walletIsReady';

export const listenWujieEvent = (
  name: WujieEventName,
  fn: (...args: any[]) => void
) => {
  if (isRunAsSubApp) {
    // @ts-ignore
    window.$wujie?.bus.$on(name, fn);
    return () => {
      // @ts-ignore
      window.$wujie?.bus.$off(name, fn);
    };
  }
  return () => {};
};

export const handleDeposit = ({ chainCode = 'BTC', coinName = 'BTC' }) => {
  if (!isRunAsSubApp) {
    return;
  }
  const wujie = (window as any).$wujie;
  wujie?.bus.$emit('deposit', {
    chainCode,
    token: coinName,
  });
};

export const handleLogin = () => {
  if (!isRunAsSubApp) {
    return;
  }
  const wujie = (window as any).$wujie;
  wujie?.bus.$emit('login');
};

export const handleCreateWallet = () => {
  if (!isRunAsSubApp) {
    return;
  }
  const wujie = (window as any).$wujie;
  wujie?.bus.$emit('createWallet');
};

/** 切换钱包 */
export const handleSwitchWallet = () => {
  if (!isRunAsSubApp) {
    return;
  }
  const wujie = (window as any).$wujie;
  wujie?.bus.$emit('switchWallet');
};

export const emitCurrentWallet = () => {
  if (isRunAsSubApp) {
    // @ts-ignore
    window.$wujie?.bus.$emit('getCurrentWalletInfo');
  }
};

export const showConnectWalletModal = () => {
  if (isRunAsSubApp) {
    // @ts-ignore
    window.$wujie?.bus.$emit('showConnectWallet');
  }
};
